export default __webpack_public_path__ + "static/media/central_andes_2_12.bae0e5da.JPG";